<img class="background" [src]="imageUrl()" [alt]="alternativeText()" />

@let checkIconUrl = this.checkIconUrl();
@if (checkIconUrl) {
  <img class="check" alt="" [src]="checkIconUrl" />
} @else {
  <p
    class="amount"
    aria-hidden="true"
    [style]="{ color: amountColor(), fontFamily: amountFontFamily() }"
    [innerHTML]="amount() | formatReward | rewardTemplate"
  ></p>
}
